const findRoutes = (ride_list, menu, route) => {
  for (let i = 0; i < menu.length; i++) {
    let subsAvalaible =
      menu[i].sub !== undefined ? menu[i].sub.filter((m) => m.show) : []
    if (menu[i].url !== undefined && menu[i].url.name === route.name) {
      ride_list.push({
        text: menu[i].title,
        icon: menu[i].icon,
        number: menu[i].number === undefined ? 1 : menu[i].number,
        disabled: true,
        to: menu[i].url
      })
      return ride_list
    } else if (subsAvalaible.length > 0) {
      let haveSubmenu = ride_list.findIndex((m) => m.to.name === 'submenu-menu')
      let subs = findRoutes(
        ride_list.concat({
          text: menu[i].title,
          icon: menu[i].icon,
          number: menu[i].number === undefined ? 1 : menu[i].number,
          disabled: false,
          to:
            haveSubmenu === -1
              ? { name: 'submenu-menu', params: { menu: menu[i].title } }
              : menu[i].url
        }),
        menu[i].sub,
        route
      )
      if (subs.length > 0) {
        return subs
      }
    }
  }
  return []
}

export default {
  namespaced: true,
  getters: {
    getBreadcrumbs: (state, getters) => (route) => {
      let breadcrumb = findRoutes([], getters.getMenu, route)
      return breadcrumb
    },
    getMenu: (state, getters, rootState, rootGetters) => {
      return [
        {
          title: 'login',
          icon: 'fa-users',
          url: { name: 'auth-login' },
          show: !rootGetters['session/isAuth'],
          size: ''
        },
        {
          title: 'dashboard',
          //icon: 'fa-tachometer-alt',
          icon: require('@/assets/color-icons/menu/kanban.png'),
          url: { name: 'index' },
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'base_config.view_globaltax',
              'base_config.view_productiondepartment',
              'chat.add_chat',
              'chat.add_message',
              'chat.change_chat',
              'chat.change_message',
              'chat.view_chat',
              'chat.view_message',
              'contenttypes.view_contenttype',
              'currencies.view_currency',
              'events.view_eventlabels',
              'notifications.view_notification',
              'product.view_product',
              'product.view_productiondetails',
              'product.view_productionsubdetails',
              'product.view_producttemplate',
              'sales.change_orderproduct',
              'sales.view_assigneduser',
              'sales.view_order',
              'sales.view_orderdetails',
              'sales.view_orderproduct',
              'sales.view_orderstatus',
              'sales.view_suborderdate',
              'sales.view_typedate'
            ]),
          size: '',
          number: 2
        },
        {
          title: 'overview',
          //icon: 'fas fa-chart-bar',
          icon: require('@/assets/color-icons/menu/overview.png'),
          url: { name: 'overview' },
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'base_config.view_globaltax'
            ]) &&
            rootGetters['session/getPermissions'](['auditlog.view_logentry']) &&
            rootGetters['session/getPermissions'](['invoices.view_invoice']),
          size: '',
          number: 2
        },
        {
          title: 'company_management',
          //icon: 'fa fa-server',
          icon: require('@/assets/color-icons/menu/asistencia-remota.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/isAdmin'] &&
            rootGetters['session/getPermissions']([
              'settings.add_company',
              'settings.change_company',
              'packages.view_package'
            ]),
          size: '',
          sub: [
            /*{
              title: 'package',
              //icon: 'fa-archive',
              img: require('@/assets/color-icons/subdomain/cloud.png'),
              url: { name: 'package' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'packages.view_package'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  img: require('@/assets/color-icons/subdomain/cloud.png'),
                  url: { name: 'package-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'packages.add_package',
                      'packages.change_package'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'packages.view_package'
                    ]),
                  size: ''
                }
              ]
            },*/
            {
              title: 'company',
              img: require('@/assets/color-icons/subdomain/domain.png'),
              url: { name: 'company' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'settings.view_company'
                ]) &&
                rootGetters['session/getPermissions']([
                  'settings.add_company',
                  'settings.change_company'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  img: require('@/assets/color-icons/subdomain/domain.png'),
                  url: { name: 'company-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'settings.view_company'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'settings.add_company',
                      'settings.change_company'
                    ]),
                  size: ''
                }
              ]
            }
            /*{
              // Debe ser accesible solo para isAdmin
              title: 'payment',
              img: require('@/assets/color-icons/subdomain/pay.png'),
              url: { name: 'payment' },
              show:
                rootGetters['session/isAuth'] && rootGetters['session/isAdmin'],
              size: ''
            }*/
          ]
        },
        {
          title: 'customer_manager',
          //icon: 'fa-address-book',
          icon: require('@/assets/color-icons/menu/aplicacion-de-seguimiento.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions'](['customer.view_customer']) &&
            rootGetters['session/getPermissions'](['base_config.view_level']),
          size: '',
          sub: [
            {
              title: 'customer',
              img: require('@/assets/color-icons/customers/buscar.png'),
              url: { name: 'customer' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'customer.view_customer'
                ]) &&
                rootGetters['session/getPermissions']([
                  'base_config.view_level'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  url: { name: 'customer-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'customer.add_customer'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'base_config.view_level',
                      'base_config.add_level',
                      'base_config.change_level'
                    ]),
                  size: ''
                },
                {
                  title: 'form',
                  url: { name: 'customer-pkEdit' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'customer.change_customer'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'base_config.view_level',
                      'base_config.add_level',
                      'base_config.change_level'
                    ]),
                  size: ''
                }
              ]
            },
            {
              title: 'level',
              img: require('@/assets/color-icons/customers/grupo.png'),
              url: { name: 'level' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'base_config.add_level',
                  'base_config.change_level',
                  'base_config.delete_level'
                ]),
              size: ''
            },
            {
              title: 'customer_origin',
              img: require('@/assets/color-icons/menu/gestion-del-tiempo.png'),
              url: { name: 'customerOrigin' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'base_config.view_origins'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'supplier_manager',
          //icon: 'fa-address-book',
          icon: require('@/assets/color-icons/menu/mejores-practicas.png'),
          show:
            (rootGetters['session/isAuth'] &&
              rootGetters['session/getPermissions']([
                'supplier.view_supplier'
              ])) ||
            rootGetters['session/isAdmin'],
          size: '',
          sub: [
            {
              title: 'supplier',
              //icon: 'fa-address-book',
              img: require('@/assets/color-icons/suppliers/supplier.png'),
              url: { name: 'supplier' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'supplier.view_supplier'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa-address-book',
                  url: { name: 'supplier-pk' },
                  show:
                    (rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'supplier.add_supplier'
                      ])) ||
                    rootGetters['session/isAdmin'],
                  size: ''
                },
                {
                  title: 'form',
                  icon: 'fa-address-book',
                  url: { name: 'supplier-pkEdit' },
                  show:
                    (rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'supplier.change_supplier'
                      ]) &&
                      rootGetters['session/getPermissions']([
                        'base_config.view_term'
                      ])) ||
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              title: 'discrepancy',
              //icon: 'fa fa-file',
              img: require('@/assets/color-icons/inventory/discrepancy.png'),
              url: { name: 'discrepancies' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'purchase.view_purchaseorderproduct'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'sale',
          icon: require('@/assets/color-icons/menu/productivo.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'sales.view_order',
              'product.view_producttemplate',
              'sales.view_orderstatus',
              'sales.view_suborderdate',
              'invoices.view_paymenttype',
              'invoices.view_receivable',
              'invoices.view_invoice',
              'sales.view_assigneduser'
            ]),
          size: '',
          sub: [
            {
              title: 'order',
              img: require('@/assets/color-icons/sale/order.png'),
              url: { name: 'sale' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['sales.view_order']),
              size: '',
              sub: [
                {
                  title: 'form',
                  img: require('@/assets/new-icons/task-list.svg'),
                  url: { name: 'sale-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'sales.add_order'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'sales.change_order'
                    ]),
                  size: ''
                }
              ]
            },
            {
              // Este módulo se reformulará, por ahora no tiene función.
              title: 'delivery',
              icon: 'fa fa-shipping-fast',
              url: { name: 'delivery' },
              // se agrega el permiso para ver el módulo de delivery en otras empresas
              show:
                rootGetters['session/isAuth'] &&
                (rootGetters['session/isAdmin'] ||
                  rootGetters['session/getPermissions']([
                    'sales.view_delivery'
                  ])),
              size: ''
            },
            {
              title: 'receivable',
              img: require('@/assets/color-icons/sale/accounts.png'),
              url: { name: 'receivable' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'invoices.view_receivable'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa-file-invoice',
                  url: { name: 'receivable-pk' },
                  number: 1,
                  withData: true,
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'invoices.view_receivable'
                    ]),
                  size: ''
                }
              ]
            }
          ]
        },
        {
          title: 'purchase',
          //icon: 'fa fa-file-invoice',
          icon: require('@/assets/color-icons/menu/consejos-y-trucos.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'purchase.view_purchaseorder'
            ]),
          size: '',
          sub: [
            {
              title: 'order',
              img: require('@/assets/color-icons/purchase/order.png'),
              url: { name: 'purchase' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'purchase.view_purchaseorder'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'icon-request',
                  url: { name: 'purchase-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              title: 'purchase_history',
              img: require('@/assets/color-icons/purchase/order.png'),
              url: { name: 'purchaseHistory' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'purchase.view_purchaseorder'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'inventory',
          //icon: 'fa fa-box',
          icon: require('@/assets/color-icons/menu/lista-de-quehaceres.png'),
          show:
            (rootGetters['session/isAuth'] &&
              rootGetters['session/getPermissions']([
                'inventory.view_movement'
              ])) ||
            rootGetters['session/isAdmin'],
          size: '',
          sub: [
            {
              title: 'physicalInventory',
              //icon: 'fa-file-invoice',
              img: require('@/assets/color-icons/inventory/transactions.png'),
              url: { name: 'movement' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'inventory.view_movement'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa-file-invoice',
                  url: { name: 'movement-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              title: 'physicalDiscrepancy',
              img: require('@/assets/color-icons/inventory/discrepancy.png'),
              url: { name: 'physicalDiscrepancies' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'inventory.view_movement'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'product_manage',
          icon: require('@/assets/color-icons/menu/escritorio.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'product.view_product',
              'product.add_priceformula',
              'product.change_priceformula',
              'product.add_priceformulaattributes',
              'product.change_priceformulaattributes',
              'product.view_priceformulaattributes',
              'matrix.view_matrix',
              'matrix.view_matrixtemplate',
              'product.view_productiondetails',
              'base_config.view_productiondepartment',
              'product.view_apparelcolor'
            ]) &&
            rootGetters['session/getPermissions'](['sales.view_typedate']) &&
            rootGetters['session/getPermissions']([
              'product.view_producttemplate'
            ]),
          size: '',
          number: 2,
          sub: [
            {
              title: 'product',
              img: require('@/assets/color-icons/product/products.png'),
              url: { name: 'product' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_product'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.add_product',
                  'product.change_product'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.view_producttemplate'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa-box',
                  url: { name: 'product-pk' },
                  show:
                    (rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'product.view_product'
                      ])) ||
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              title: 'production_details_template',
              img: require('@/assets/color-icons/product/templates.png'),
              url: { name: 'templatesProduct' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_producttemplate'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.add_producttemplate',
                  'product.change_producttemplate'
                ]) &&
                rootGetters['session/getPermissions'](['product.view_process']),
              size: '',
              sub: [
                {
                  title: 'form',
                  img: require('@/assets/new-icons/template.svg'),
                  url: { name: 'templatesProduct-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'product.view_producttemplate'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'product.add_producttemplate',
                      'product.change_producttemplate'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'product.view_process'
                    ]),
                  size: ''
                }
              ]
            },
            {
              title: 'formula',
              img: require('@/assets/color-icons/product/pricingformula.png'),
              url: { name: 'formula' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_priceformula',
                  'product.view_priceformulaattributes'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.add_priceformula',
                  'product.change_priceformula'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.add_priceformulaattributes',
                  'product.change_priceformulaattributes'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'icon-calculating',
                  url: { name: 'formula-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'product.add_priceformula',
                      'product.change_priceformula'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'product.add_priceformulaattributes',
                      'product.change_priceformulaattributes'
                    ]),
                  size: ''
                }
              ]
            },
            {
              title: 'matrix',
              img: require('@/assets/color-icons/product/matrix.png'),
              url: { name: 'matrix' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'matrix.add_matrixtemplate',
                  'matrix.change_matrixtemplate',
                  'matrix.delete_matrixtemplate'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa-th',
                  url: { name: 'matrix-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'matrix.add_matrixtemplate'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'matrix.change_matrixtemplate'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'matrix.delete_matrixtemplate'
                    ]),
                  size: ''
                }
              ]
            },
            {
              title: 'department',
              img: require('@/assets/color-icons/product/productiondepartmet.png'),
              url: { name: 'department' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'base_config.view_productiondepartment'
                ]) &&
                rootGetters['session/getPermissions']([
                  'base_config.add_productiondepartment',
                  'base_config.change_productiondepartment'
                ]),
              size: ''
            },
            {
              title: 'typedate',
              img: require('@/assets/color-icons/settings/date_type.png'),
              url: { name: 'typeDate' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'sales.view_typedate'
                ]) &&
                rootGetters['session/getPermissions']([
                  'sales.add_typedate',
                  'sales.change_typedate'
                ]) &&
                rootGetters['session/getPermissions']([
                  'product.view_producttemplate'
                ]),
              size: ''
            },
            {
              title: 'apparel_names',
              icon: 'fa-tshirt',
              url: { name: 'apparel-name' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['product.view_apparel']),
              size: ''
            },
            {
              title: 'apparel_colors',
              icon: 'fa-palette',
              url: { name: 'apparelColor' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_apparelcolor'
                ]),
              size: ''
            },
            {
              title: 'apparel_styles',
              icon: 'fa-tags',
              url: { name: 'apparel-styles' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_apparelstyle'
                ]),
              size: ''
            },
            {
              title: 'fabric_types',
              icon: 'fa-swatchbook',
              url: { name: 'fabric-types' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_fabrictype'
                ]),
              size: ''
            },
            {
              title: 'apparel_brands',
              icon: 'fa-copyright',
              url: { name: 'apparel-brands' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_apparelbrand'
                ]),
              size: ''
            },
            {
              title: 'apparel_genders',
              icon: 'fa-venus-mars',
              url: { name: 'apparel-genders' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_apparelgender'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'expense',
          //icon: 'fa-dollar-sign',
          icon: require('@/assets/color-icons/menu/trabajar-desde-casa.png'),
          show:
            (rootGetters['session/isAuth'] &&
              rootGetters['session/getPermissions']([
                'expenses.view_category',
                'expenses.view_account',
                'expenses.view_expense'
              ])) ||
            rootGetters['session/isAdmin'],
          size: '',
          number: 2,
          sub: [
            {
              title: 'expenses_regular',
              //img: require('@/assets/new-icons/expenses.svg'),
              img: require('@/assets/color-icons/expenses/expense.png'),
              url: { name: 'expensesRegular' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'expenses.view_expense'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa fa-file',
                  url: { name: 'expensesRegular-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              title: 'expenses_recurring',
              //img: require('@/assets/new-icons/expenses.svg'),
              img: require('@/assets/color-icons/expenses/expense.png'),
              url: { name: 'expensesRecurring' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'expenses.view_expense'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'fa fa-file',
                  url: { name: 'expensesRecurring-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              title: 'expenseCategory',
              //img: require('@/assets/new-icons/expensesCategory.svg'),
              img: require('@/assets/color-icons/expenses/expense_category.png'),
              url: { name: 'expenseCategory' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'expenses.view_category'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: ''
            },
            {
              title: 'expenseAccount',
              //img: require('@/assets/new-icons/expenseAccount.svg'),
              img: require('@/assets/color-icons/expenses/expense_account.png'),
              url: { name: 'expenseAccount' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'expenses.view_account'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: ''
            }
          ]
        },
        {
          title: 'equipments_manage',
          //icon: 'fa-wrench',
          icon: require('@/assets/color-icons/menu/comunicacion-en-linea.png'),
          show:
            (rootGetters['session/isAuth'] &&
              rootGetters['session/getPermissions']([
                'equipements.view_equipement',
                'equipements.view_brandmodel'
              ])) ||
            rootGetters['session/isAdmin'],
          size: '',
          number: 2,
          sub: [
            {
              title: 'equipments',
              img: require('@/assets/color-icons/equipment/equipments.png'),
              url: { name: 'equipment' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'equipements.view_equipement'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  url: { name: 'equipment-pk' },
                  show:
                    (rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'equipements.add_equipement'
                      ])) ||
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              title: 'equipment_maintenance',
              url: { name: 'maintenance' },
              show: false,
              size: '',
              sub: [
                {
                  title: 'form',
                  url: { name: 'maintenance-pk' },
                  show:
                    (rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'equipements.add_maintenance',
                        'equipements.change_maintenance',
                        'equipements.delete_maintenance'
                      ])) ||
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              title: 'brand',
              img: require('@/assets/color-icons/equipment/brand.png'),
              url: { name: 'brand' },
              show:
                (rootGetters['session/isAuth'] &&
                  rootGetters['session/getPermissions']([
                    'equipements.view_brandmodel'
                  ])) ||
                rootGetters['session/isAdmin'],
              size: ''
            }
          ]
        },
        /*
        {
          title: 'chat',
          //icon: 'fa-comment',
          icon: require('@/assets/color-icons/menu/comunicaciones.png'),
          url: { name: 'chat' },
          show:
            (rootGetters['session/isAuth'] &&
              rootGetters['session/getPermissions'](['chat.view_chat'])) ||
            rootGetters['session/isAdmin'],
          size: ''
        },
        */
        {
          title: 'reports',
          icon: require('@/assets/color-icons/menu/trituradora-de-papel.png'),
          // Solo el rol administador no root tiene permiso de agregar y editar usuarios
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions'](['auth.add_user']) &&
            rootGetters['session/getPermissions'](['auth.change_user']),
          size: '',
          sub: [
            {
              title: 'customersReport',
              img: require('@/assets/color-icons/reports/customer_report.png'),
              url: { name: 'customersReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'customer.view_customer'
                ]),
              size: ''
            },
            {
              title: 'suppliersReport',
              img: require('@/assets/color-icons/reports/suppliers_report.png'),
              url: { name: 'suppliersReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'supplier.view_supplier'
                ]),
              size: ''
            },
            {
              title: 'equipmentReport',
              img: require('@/assets/color-icons/reports/equipment_report.png'),
              url: { name: 'equipmentsReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'equipements.view_equipement'
                ]),
              size: ''
            },
            {
              title: 'expensesReport',
              img: require('@/assets/color-icons/reports/expenses_report.png'),
              url: { name: 'expensesReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'expenses.view_expense'
                ]),
              size: ''
            },
            {
              title: 'invoicesReport',
              img: require('@/assets/color-icons/reports/invoices_report.png'),
              url: { name: 'invoicesReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'invoices.view_invoice'
                ]),
              size: ''
            },
            {
              title: 'salesReport',
              img: require('@/assets/color-icons/reports/sales_report.png'),
              url: { name: 'salesReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['sales.view_order']),
              size: ''
            },
            {
              title: 'purchasesReport',
              img: require('@/assets/color-icons/reports/purchases_report.png'),
              url: { name: 'purchasesReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'purchase.view_purchaseorder'
                ]),
              size: ''
            },
            {
              title: 'productReport',
              img: require('@/assets/color-icons/reports/inventory_report.png'),
              url: { name: 'inventory' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'inventory.view_movement'
                ]),
              size: ''
            },
            {
              title: 'movementsReport',
              img: require('@/assets/color-icons/reports/movements_report.png'),
              url: { name: 'movementsReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'inventory.view_movement'
                ]),
              size: ''
            },
            {
              title: 'designerReport',
              img: require('@/assets/color-icons/reports/customer_report.png'),
              url: { name: 'designerReport' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['sales.view_order']),
              size: ''
            }
          ]
        },
        {
          title: 'whatsapp',
          icon: require('@/assets/new-icons/whatsapp.svg'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'whatsapp.view_inbox',
              'whatsapp.view_conversation',
              'whatsapp.view_account'
            ]),
          size: '',
          // Sin el complemento la entrada no desaparece: lleva a la pantalla
          // que lo ofrece. Un hueco en el menú no se explica solo, y la
          // configuración del canal no tiene sentido sin haberlo contratado.
          ...(rootGetters['whatsapp/getHasAddon']
            ? {
                sub: [
                  {
                    title: 'inbox',
                    img: require('@/assets/new-icons/whatsapp.svg'),
                    url: { name: 'whatsapp' },
                    show:
                      rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'whatsapp.view_inbox',
                        'whatsapp.view_conversation'
                      ]),
                    size: ''
                  },
                  {
                    title: 'settings',
                    img: require('@/assets/color-icons/settings/notificationssettings.png'),
                    url: { name: 'whatsapp-settings' },
                    show:
                      rootGetters['session/isAuth'] &&
                      rootGetters['session/getPermissions']([
                        'whatsapp.change_account',
                        'whatsapp.toggle_integration',
                        'whatsapp.view_account'
                      ]),
                    size: ''
                  }
                ]
              }
            : { url: { name: 'whatsapp-upgrade' } })
        },
        {
          title: 'notifications_events',
          icon: require('@/assets/color-icons/settings/notifications.png'),
          show:
            rootGetters['session/isAuth'] &&
            rootGetters['session/getPermissions']([
              'notifications.add_notification',
              'notifications.change_notification',
              'events.view_event'
            ]),
          size: '',
          sub: [
            {
              title: 'notifications_events',
              img: require('@/assets/color-icons/settings/notifications.png'),
              url: { name: 'notifications' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['events.view_event']),
              size: ''
            },
            {
              title: 'settings',
              img: require('@/assets/color-icons/settings/notificationssettings.png'),
              url: { name: 'notifications-settings' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'notifications.add_notification',
                  'notifications.change_notification'
                ]),
              size: ''
            }
          ]
        },
        {
          title: 'settings',
          icon: require('@/assets/color-icons/menu/gestion-del-tiempo.png'),
          show: rootGetters['session/isAuth'],
          size: '',
          sub: [
            {
              title: 'company_info',
              img: require('@/assets/color-icons/settings/company_information.png'),
              url: { name: 'settings' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'settings.view_company'
                ]) &&
                rootGetters['session/getPermissions']([
                  'settings.change_company'
                ]),
              size: ''
            },
            {
              title: 'invoiceSetting',
              img: require('@/assets/color-icons/settings/invoicing_configuration.png'),
              url: { name: 'invoice-setting' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'invoices.view_settings'
                ]),
              size: ''
            },
            {
              title: 'paymenttype',
              img: require('@/assets/color-icons/sale/payment-method.png'),
              url: { name: 'paymenttype' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'invoices.view_paymenttype'
                ]),
              size: ''
            },
            {
              title: 'sequence',
              img: require('@/assets/color-icons/settings/sequence.png'),
              url: { name: 'sequence' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'sequences.view_sequence'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'icon-secuencias',
                  url: { name: 'sequence-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'sequences.add_sequence',
                      'sequences.change_sequence'
                    ]),
                  size: ''
                }
              ]
            },
            {
              title: 'terms',
              img: require('@/assets/color-icons/settings/term_condition.png'),
              url: { name: 'terms' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'base_config.view_term'
                ]),
              size: ''
            },
            {
              title: 'measure',
              img: require('@/assets/color-icons/settings/unit_measure.png'),
              url: { name: 'soldBy' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'base_config.view_soldby'
                ]),
              size: ''
            },
            {
              title: 'templates_email',
              img: require('@/assets/color-icons/settings/email_templates.png'),
              url: { name: 'templatesEmail' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'emails.view_template',
                  'emails.view_configtemplate',
                  'product.view_producttemplate'
                ]) &&
                rootGetters['session/getPermissions']([
                  'emails.add_template',
                  'emails.change_template'
                ]) &&
                rootGetters['session/getPermissions']([
                  'emails.add_configtemplate',
                  'emails.change_configtemplate'
                ]),
              size: ''
            },
            {
              title: 'emails_list',
              img: require('@/assets/color-icons/email/letter.png'),
              url: { name: 'sendEmail' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['emails.view_maillist']),
              size: '',
              sub: [
                {
                  title: 'form',
                  url: { name: 'sendEmail-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              title: 'email_setting.email_SMTP_setting',
              img: require('@/assets/color-icons/settings/smtpsetting.png'),
              url: { name: 'emailSettings' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'emails.view_credentials'
                ]),
              size: ''
            },
            {
              title: 'settingImage',
              icon: 'fa-upload',
              url: '/settingImage',
              show: false,
              size: ''
            },
            {
              // Debe ser accesible solo para isAdmin
              title: 'backup_schemas',
              img: require('@/assets/color-icons/settings/backup.png'),
              url: { name: 'backupSchemas' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'settings.view_company'
                ]),
              size: ''
            },
            {
              title: 'audit',
              img: require('@/assets/color-icons/settings/audit.png'),
              url: { name: 'auditlog' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'auditlog.view_logentry'
                ]),
              size: ''
            },
            {
              title: 'user',
              img: require('@/assets/color-icons/settings/users.png'),
              url: { name: 'users' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['auth.view_user']) &&
                rootGetters['session/getPermissions'](['auth.change_user']) &&
                rootGetters['session/getPermissions'](['auth.add_user']),
              size: '',
              number: 1,
              sub: [
                {
                  title: 'form',
                  icon: 'icon-users',
                  url: { name: 'users-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions'](['auth.view_user']) &&
                    rootGetters['session/getPermissions']([
                      'auth.change_user'
                    ]) &&
                    rootGetters['session/getPermissions'](['auth.add_user']),
                  size: '',
                  number: 1
                }
              ]
            },
            {
              // Debe ser accesible solo para isAdmin
              title: 'carrouselTips',
              img: require('@/assets/color-icons/settings/tips_carrousel.png'),
              url: { name: 'carrouselTips' },
              show:
                rootGetters['session/isAuth'] && rootGetters['session/isAdmin'],
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'icon-prioritize',
                  url: { name: 'carrouselTips-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              // Debe ser accesible solo para isAdmin
              title: 'currency',
              img: require('@/assets/color-icons/settings/currency.png'),
              url: { name: 'currency' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/isAdmin'] &&
                rootGetters['session/getPermissions']([
                  'currencies.view_currency'
                ]),
              size: '',
              sub: [
                {
                  title: 'form',
                  icon: 'icon-Currency',
                  url: { name: 'currency-pk' },
                  show: rootGetters['session/isAuth'],
                  size: ''
                }
              ]
            },
            {
              // Debe ser accesible solo para isAdmin
              title: 'roles',
              img: require('@/assets/color-icons/settings/roles.png'),
              url: { name: 'roles' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions'](['auth.view_group']) &&
                rootGetters['session/getPermissions']([
                  'auth.add_group',
                  'auth.change_group'
                ]) &&
                rootGetters['session/getPermissions']([
                  'contenttypes.view_contenttype'
                ]) &&
                rootGetters['session/isAdmin'],
              size: '',
              number: 2,
              sub: [
                {
                  title: 'form',
                  icon: 'fa-users-slash',
                  url: { name: 'roles-pk' },
                  show:
                    rootGetters['session/isAuth'] &&
                    rootGetters['session/getPermissions']([
                      'auth.view_group'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'auth.add_group',
                      'auth.change_group'
                    ]) &&
                    rootGetters['session/getPermissions']([
                      'contenttypes.view_contenttype'
                    ]) &&
                    rootGetters['session/isAdmin'],
                  size: ''
                }
              ]
            },
            {
              title: 'orderstatus',
              img: require('@/assets/color-icons/sale/order-status.png'),
              url: { name: 'orderstatus' },
              show:
                rootGetters['session/isAuth'] &&
                rootGetters['session/getPermissions']([
                  'product.view_producttemplate'
                ]) &&
                rootGetters['session/getPermissions']([
                  'sales.view_orderstatus'
                ]) &&
                rootGetters['session/getPermissions']([
                  'sales.add_orderstatus',
                  'sales.change_orderstatus'
                ]),
              size: ''
            }
          ]
        }
      ]
    }
  }
}
